<template>
  <div>
    <form-table style="padding: 0; margin-top: 10px">
      <template slot="table">
        <v-data-table
            ref="table"
            :headers="colunas"
            :items="itens"
            :server-items-length="totalItens"
            :options.sync="paginacaoInterna"
            :loading="false"
            no-data-text="Não há serviços registrados para o atendimento."
            class="table-list"
            hide-default-footer
            @click:row="tratarEventoAcessar">
          <template #item.titulo="{ item }">
            <MolensTooltip max-width="300px">
              <span class="max-label">{{ item.titulo | textoSemValor }}</span>
              <template #content>
                {{ item.observacao | textoSemValor }}
              </template>
            </MolensTooltip>
          </template>
          <template #item.quantidade="{item}">
            <span>{{ item.quantidade | textoSemValor }}</span>
          </template>
          <template #item.valor="{item}">
            <span>{{ item.valor | valorParaReal }}</span>
          </template>
          <template #item.valorTotal="{item}">
            <span>{{ item.valorTotal | valorParaReal }}</span>
          </template>
          <template #item.acoes="{  }">
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="mobile">Acessar</span>
          </template>
        </v-data-table>
      </template>

      <template slot="footer">
        <div class="pagination">
          <v-pagination
              v-if="paginas > 1"
              v-model="paginacaoInterna.page"
              total-visible="7"
              :length="paginas"
          />
          <v-spacer v-if="paginas <= 1"/>
          <div class="select-pagination">
            <span>Linhas por página:</span>
            <v-select :items="linhasPorPagina" @change="resetaPage" v-model="paginacaoInterna.size"/>
          </div>
        </div>
      </template>

    </form-table>
  </div>
</template>

<script>
import mutationTypes from '@/core/constants/mutationTypes'
import FormTable from '@/views/components/FormTable.vue'
import MolensTooltip from '@/views/components/MolensTooltip.vue'

export default {
    name: 'OdontogramaGerenciarServicosAtendimentoTabela',
    components: {MolensTooltip, FormTable},
    props: ['itens', 'paginacao', 'paginas', 'totalItens'],
    data() {
        return {
            colunas: [
                {
                    text: 'Título',
                    value: 'titulo',
                    sortable: false,
                    align: 'left',
                    width: '20%',
                    class: 'gray--text'
                },
                {
                    text: 'Quantidade',
                    value: 'quantidade',
                    sortable: false,
                    align: 'center',
                    width: '10%',
                    class: 'gray--text'
                },
                {
                    text: 'Valor Un.',
                    value: 'valor',
                    sortable: false,
                    align: 'left',
                    width: '120px',
                    class: 'gray--text'
                },
                {
                    text: 'Valor Total',
                    value: 'valorTotal',
                    sortable: false,
                    align: 'left',
                    width: '120px',
                    class: 'gray--text'
                },
                {
                    text: '',
                    value: 'acoes',
                    sortable: false,
                    align: 'right',
                    width: '10%',
                    class: 'gray--text'
                }
            ],
            paginacaoInterna: this.paginacao,
            linhasPorPagina: [10, 25, 50, 100],
        }
    },
    methods: {
        tratarEventoAcessar(item) {
            this.$emit('acessar', item)
        },
        resetaPage() {
            this.$store.commit(mutationTypes.SERVICO_ATENDIMENTO.RESETA_PAGE_SERVICO_ATENDIMENTO)
        },
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true,
        },
    },
}
</script>


<style scoped lang="stylus">
.max-label
  display inline-block
  max-width 10vw
  white-space nowrap
  overflow hidden
  text-overflow ellipsis

@media (max-width: 720px)
  .max-label
    max-width 40vw !important
</style>